import UnauthenticatedPage from 'dashboard/components/UnauthenticatedPage';
import FormUpdatePassword from 'dashboard/forms/FormUpdatePassword';
import Spacer from 'design-system/components/Spacer';
import { Heading } from 'design-system/components/Text';

interface DashboardPasswordResetConfirmViewProps {
  confirmPasswordReset: (values: any) => void;
}

export default ({ confirmPasswordReset }: DashboardPasswordResetConfirmViewProps) => {
  return (
    <UnauthenticatedPage>
      <Heading size='sm'>Enter a new password</Heading>
      <Spacer height={2.5} />
      <FormUpdatePassword onSubmit={confirmPasswordReset} />
    </UnauthenticatedPage>
  );
};
